import { render, staticRenderFns } from "./CollectiveRequestForm.vue?vue&type=template&id=18dc0f15&scoped=true&"
import script from "./CollectiveRequestForm.vue?vue&type=script&lang=js&"
export * from "./CollectiveRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectiveRequestForm.vue?vue&type=style&index=0&id=18dc0f15&scoped=true&lang=css&"
import style1 from "./CollectiveRequestForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc0f15",
  null
  
)

export default component.exports